module.exports = __webpack_public_path__ + "img/CH01-034-035.3722d467.jpg";